import React from 'react';
import BaseClass from '@/pages/BaseClass';

import {
	Form,
	Input,
	InputNumber,
	Button,
} from 'antd'
import $ from 'jquery';
import AddOrder from '@/components/AddOrder';
import {
	CommonValue,
	ngUrl,
} from '@/utils/Tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'orderType':0,
		};
	}
	
	componentDidMount()
	{
		let selection = CommonValue.get('selected_image_list');
		let orderType = CommonValue.get('selected_order_type');
		this.state.orderType = orderType;
		
		this.addOrder.init({
			'imageList':selection,
			'orderType':orderType,
		});
	}
	
	changeCart(imageIds)
	{
		let cartList = CommonValue.get('cart_list') || [];
		cartList = cartList.filter(row=>imageIds.includes(row['image_id']));
		
		CommonValue.set('cart_list',cartList);
	}
	
	back()
	{
		//window.history.back();
		window.location.href = ngUrl('imageList',{'type':this.state.orderType},true);
	}
	
	render()
	{
		return (
			<AddOrder back={()=>this.back()} changeCart={(imageIds)=>this.changeCart(imageIds)} ref={e=>this.addOrder = e} />
		);
	}
}


